import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const Features = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'Features'} category={['features']} />
        </Layout>
    )
}

export default Features
